import { ReactComponent as LowRisk } from './low-risk.svg'
export default LowRisk
